import {
  createFileRoute,
  notFound,
  redirect,
  useNavigate,
} from "@tanstack/react-router";
import { z } from "zod";
import { useAuth } from "@/features/auth/store";
import {
  ArrivalListPage,
} from "@/features/arrival/components/list/arrival-list-page";
import {
  FORM_PENDING,
  formCodeOf,
  formTitle,
  isFormSlug,
} from "@/features/arrival/forms";

/** `tab` is a document status (Pending / Unloading / Preview / Submitted / Cancelled). */
const search = z.object({
  tab: z.string().optional(),
  q: z.string().optional(),
  from: z.string().optional(),
  to: z.string().optional(),
  page: z.number().int().min(1).default(1),
});

/** One form's list. The slug is in the path so the rail highlights exactly this entry. */
export const Route = createFileRoute("/_app/arrivals/$form/")({
  params: {
    parse: ({ form }) => {
      if (!isFormSlug(form)) throw notFound();
      return { form };
    },
    stringify: (p) => p,
  },
  validateSearch: search,
  beforeLoad: ({ params }) => {
    const auth = useAuth.getState();
    // A form the login's roles do not grant lands where the rail would have sent them.
    if (
      !auth.can("document.view") ||
      !auth.canViewForm(formCodeOf(params.form))
    )
      throw redirect({ to: "/" });
  },
  component: Page,
});

function Page() {
  const { form } = Route.useParams();
  const s = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  return (
    <ArrivalListPage
      title={formTitle(form)}
      formCode={formCodeOf(form)}
      slug={form}
      pendingView={FORM_PENDING[form]}
      search={{ ...s, tab: s.tab ?? "draft" }}
      onSearch={(next) =>
        void navigate({ search: (prev) => ({ ...prev, ...next }) })
      }
    />
  );
}
